import { publicPortalApi } from '@/api/publicPortal.api';

const unwrap = (response) => response.data;

export const publicPortalService = {
  getHome: async () => unwrap(await publicPortalApi.getHome()).data,
  getStats: async () => unwrap(await publicPortalApi.getStats()).data.stats,
  search: async (params) => unwrap(await publicPortalApi.search(params)).data,
  listTournaments: async (params) => unwrap(await publicPortalApi.listTournaments(params)).data,
  listTournamentsPublic: async (params) =>
    unwrap(await publicPortalApi.listTournamentsPublic(params)).data,
  listMatches: async (params) => unwrap(await publicPortalApi.listMatches(params)).data,
  getMatch: async (id) => unwrap(await publicPortalApi.getMatch(id)).data.match,
  listTeams: async (params) => unwrap(await publicPortalApi.listTeams(params)).data,
  getTeam: async (id) => unwrap(await publicPortalApi.getTeam(id)).data,
  listPlayers: async (params) => unwrap(await publicPortalApi.listPlayers(params)).data,
  getPlayer: async (id) => unwrap(await publicPortalApi.getPlayer(id)).data,
  listGrounds: async (params) => unwrap(await publicPortalApi.listGrounds(params)).data.grounds,
  getGround: async (id) => unwrap(await publicPortalApi.getGround(id)).data.ground,
  listGallery: async (params) => unwrap(await publicPortalApi.listGallery(params)).data,
  listAlbums: async (params) => unwrap(await publicPortalApi.listAlbums(params)).data,
  getAlbum: async (id) => unwrap(await publicPortalApi.getAlbum(id)).data,
  listSponsors: async (params) => unwrap(await publicPortalApi.listSponsors(params)).data,
};
